function AuthTitle(params) {
    return (
        <div className="sm:flex sm:justify-center sm:items-center">
            <div className="mb-4 sm:mb-0">
                <h1 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60">{params.children}</h1>
            </div>
        </div>
    );
}

export default AuthTitle;